import type { ChatRoomResponseBasicInfoAllOfTwoType } from './chatRoomResponseBasicInfoAllOfTwoType';

/**
 * 채팅방 기본 정보
 */
export type ChatRoomResponseBasicInfoAllOfTwo = {
  name?: string;
  type?: ChatRoomResponseBasicInfoAllOfTwoType;
};
